





















import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {

  }
})
export default class AccountDeletionContract extends Vue {
  private username: any = '';
  private topHeight = 0;
  private contentHeight = 0;
  private mounted() {
    this.username = this.$route.query.username;
    const topHeight = (this.$refs as any).topInfo.clientHeight;
    // const contentHeight = (this.$refs as any).content.clientHeight;
    const docHeight = document.body.clientHeight;
    this.contentHeight = docHeight - topHeight - 20;
  }
}
